<template>
  <v-chip label class="primary" outlined>
    <v-icon small color="primary" class="mr-2">mdi-file-document</v-icon>
    <span class="text-body-2 text-uppercase"
      >Total <span class="mx-1">-</span>
    </span>
    <span class="font-weight-bolder">{{ total }}</span>
  </v-chip>
</template>

<script>
export default {
  name: "basePagination",
  props: {
    total: {
      require: true,
    },
  },
};
</script>